//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'system.#01',
    colors: ['#ff4242', '#fec101', '#1841fe', '#fcbdcc', '#82e9b5'],
    stroke: '#000',
    background: '#fff',
    type: 'system',
  },
  {
    name: 'system.#02',
    colors: ['#ff4242', '#ffd480', '#1e365d', '#edb14c', '#418dcd'],
    stroke: '#000',
    background: '#fff',
    type: 'system',
  },
  {
    name: 'system.#03',
    colors: ['#f73f4a', '#d3e5eb', '#002c3e', '#1aa1b1', '#ec6675'],
    stroke: '#110b09',
    background: '#fff',
    type: 'system',
  },
  {
    name: 'system.#04',
    colors: ['#e31f4f', '#f0ac3f', '#18acab', '#26265a', '#ea7d81', '#dcd9d0'],
    stroke: '#26265a',
    backgrund: '#dcd9d0',
    type: 'system',
  },
  {
    name: 'system.#05',
    colors: ['#db4549', '#d1e1e1', '#3e6a90', '#2e3853', '#a3c9d3'],
    stroke: '#000',
    background: '#fff',
    type: 'system',
  },
  {
    name: 'system.#06',
    colors: ['#e5475c', '#95b394', '#28343b', '#f7c6a3', '#eb8078'],
    stroke: '#000',
    background: '#fff',
    type: 'system',
  },
  {
    name: 'system.#07',
    colors: ['#d75c49', '#f0efea', '#509da4'],
    stroke: '#000',
    background: '#fff',
    type: 'system',
  },
  {
    name: 'system.#08',
    colors: ['#f6625a', '#92b29f', '#272c3f'],
    stroke: '#000',
    background: '#fff',
    type: 'system',
  },
];
